import { api } from "./api";
import { formatPrice } from "../utils/FormatCurrency";
export const applyVoucher = async (voucherCode, cartTotalPrice) => {
    try {
      const response = await api.post("/Coupons/validate", {
        code: voucherCode.trim()
      });
      const result = response.data.data;
  
      if (!result) throw new Error("Voucher không hợp lệ.");
  
      // Check minOrderValue
      if (result.minOrderValue && cartTotalPrice < result.minOrderValue) {
        throw new Error(`Đơn hàng phải từ ${formatPrice(result.minOrderValue)} trở lên để dùng voucher.`);
      }
  
      // Tính giảm giá
      let discount = 0;
      if (result.discountAmount) {
        discount = result.discountAmount;
      } else if (result.discountPercentage) {
        discount = (cartTotalPrice * result.discountPercentage) / 100;
        if (result.maxDiscountAmount) {
          discount = Math.min(discount, result.maxDiscountAmount);
        }
        discount = Math.round(discount);
      }
  
      return {
        code: result.code,
        discountAmount: discount,
        isFreeShipping: result.isFreeShipping || false
      };
    } catch (error) {
      const errMsg = error.response?.data?.message || error.message || "Không thể kiểm tra voucher.";
      throw new Error(errMsg);
    }
  };
  
  // Hàm lưu voucher vào localStorage
  export const saveVoucherToLocal = (voucherData) => {
    localStorage.setItem("appliedVoucher", JSON.stringify(voucherData));
  };
  
  // Hàm lấy voucher từ localStorage
  export const loadVoucherFromLocal = () => {
    const data = localStorage.getItem("appliedVoucher");
    return data ? JSON.parse(data) : null;
  };
  
  // Hàm xóa voucher trong localStorage
  export const clearVoucherFromLocal = () => {
    localStorage.removeItem("appliedVoucher");
  };